'use strict';

/* global document */

var $ = require('jquery');

module.exports = {
  template: '<span style="display: none !important;"><slot></slot></span>',
  methods: {
    updateApplicationTitle: function() {
      document.title = $(this.$el).text();
    }
  },
  mounted: function() {
    this.updateApplicationTitle();
  },
  updated: function() {
    this.updateApplicationTitle();
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/scripts/shared/components/application-title/index.js
// module id = 192
// module chunks = 0